export default "skymp5-front/48b4bad0bb269068957bc85943c28df6.gif";